<template>
    <a :href="createUrl">
        <div
            class="icon-button icon-button--primary icon-button--text"
            v-if="text"
        >
            {{ text }}
        </div>
        <div class="icon-button icon-button--primary" v-else>
            <div class="icon-button__icon">
                <img src="/images/icons/create.svg" alt="" />
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: ['createUrl', 'text'],
};
</script>
